import React from "react";
import ReactDOM from "react-dom";
import { Images } from "../../../Assets/0a-exporter";
import "./preview-candidate.style.scss";
export default function PreviewCandidate({ closeIt }) {
  return ReactDOM.createPortal(
    <div onClick={() => closeIt()} className="preview-candidate-main">
      <div
        onClick={(e) => e.stopPropagation()}
        className="preview-candidate-modal"
      >
        <div className="user-profile-main">
          <header className="upm-header">
            <h5>Personal details</h5>
          </header>
          <div className="upm-basic-info-row">
            <div className="ubir-first">
              <div className="ubirf-profile">
                <label>
                  <img className="main-image" />
                  <button>
                    <img src={Images.blueCamera} />
                  </button>
                </label>
                <div>
                  <div>
                  <h6>Jany DOe</h6>
                  <span>ID 1238975</span>
                  </div>
                  <div>
                  <img src={Images.penPage} />
                  <span>Download resume</span>
                </div>

                </div>

                
              </div>
              <div className="ubir-second">
              <div className="ubirs-row">
                <p>
                  <img src={Images.email} />
                  <span>johnsilva@gmail.com</span>
                </p>
              </div>
              <div className="ubirs-row">
                <p>
                  <img src={Images.userLogo} />
                  <span>Female</span>
                </p>
              </div>
              <div className="ubirs-row">
                <p>
                  <img src={Images.callLogo} />
                  <span>+91 - 8776743698</span>
                  {/* <button>Verify</button> */}
                </p>
              </div>
              <div className="ubirs-row">
                <p>
                  <img src={Images.manWIthStars} />
                  <span>Exp : 3.6 years</span>
                </p>
              </div>
              <div className="ubirs-row">
                <p>
                  <img src={Images.locationLogo} />
                  <span>Bengaluru</span>
                </p>
              </div>
              <div className="ubirs-skill-row">
                {[
                  "Communication",
                  "Skill set 4",
                  "Art & Dance",
                  "Skill Set 5",
                  "Good listener",
                ].map((x) => (
                  <button>{x}</button>
                ))}
              </div>
            </div>

            </div>
            <div className="candidate-status-new">
                <div className="cs-upper">
                  <span>Interview status</span>
                  <div>
                  <img src={Images.cvBorderLogo} />
                  <span>Add Comments</span>
                </div>

                </div>
                <div className="cs-lower">
                <span>1</span>
                  <div>
                  <span>No action taken</span>
                <div>
                  <button>Review Application</button>
                  <img src={Images.noAction} />

                </div>

                  </div>

                </div>{" "}
              </div>


          </div>
          <div className="ubi-cards-wrapper">
            <heder className="ubicw-header">
              <h5>Work experience</h5>
              <button>
                <img src={Images.addIcon} />
                Add New
              </button>
            </heder>
            <div className="ubicw-body">
              {[1, 2, 3].map((x) => (
                <div className="ubicw-card">
                  <figure>
                    <img src={Images.menTree} />
                  </figure>

                  <figcaption>
                    <h5>Maths Teacher</h5>
                    <h6>Indian institute of Science</h6>
                    <p>Mar 2014 – Present 7 yrs 6 mon</p>
                    <p>Bangalore India</p>
                  </figcaption>
                </div>
              ))}
            </div>
          </div>

          <div className="ubi-cards-wrapper">
            <heder className="ubicw-header">
              <h5>Education</h5>
              <button>
                <img src={Images.addIcon} />
                Add New
              </button>
            </heder>
            <div className="ubicw-body">
              {[1, 2, 3].map((x) => (
                <div className="ubicw-card">
                  <figure>
                    <img src={Images.menTree} />
                  </figure>

                  <figcaption>
                  <h5>Indian Institute of Science - Bengaluru</h5>
                    <p>Bachelor's degree, Computer Engineering</p>
                    <p>Bangalore India</p>
                  </figcaption>
                </div>
              ))}
            </div>
          </div>

          <div className="ubi-preference">
            <header className="ubip-header">
              <h5>Comments</h5>
            </header>
            <div className="ubip-body">
            <textarea
              rows="6"
              style={{ height: "auto" }}
              cols={10}
              // onChange={(e) =>
              //   setInstitutionDetails({
              //     ...institutionDetails,
              //     about_institution: e.target.value,
              //   })
              // }
              // value={institutionDetails.about_institution}
              placeholder="Type Your Comments Here."
              // required
            />
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
